import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TicketService } from 'src/app/private/services/tickets.service';
import "amazon-connect-streams";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { CreateTicketComponent } from "../../components/tickets/create-ticket/create-ticket.component";
import { TicketCardViewComponent } from "../../components/tickets/ticket-card-view/ticket-card-view.component";
import { DeleteTicketComponent } from "../../components/tickets/delete-ticket/delete-ticket.component";
import { AppFloatingConfigurator } from "src/app/layout/component/app.floatingconfigurator";
import { UsersService } from 'src/app/private/services/users.service';
import { BulkActionComponent } from '../../components/tickets/bulk-action/bulk-action.component';
import { DeleteBulkTicketComponent } from "../../components/tickets/delete-bulk-ticket/delete-bulk-ticket.component";
import { TicketFilterSidebarComponent } from "../../components/tickets/ticket-filter-sidebar/ticket-filter-sidebar.component";
import { TicketActivityTabComponent } from "../../components/tickets/ticket-activity-tab/ticket-activity-tab.component";
import { TicketMiddleViewComponent } from "../../components/tickets/ticket-middle-view/ticket-middle-view.component";

@Component({
  selector: 'app-tickets',
  imports: [ToolBarComponent, SharedModule, CreateTicketComponent, TicketCardViewComponent, DeleteTicketComponent, BulkActionComponent, DeleteBulkTicketComponent, TicketFilterSidebarComponent, TicketActivityTabComponent, TicketMiddleViewComponent],
  templateUrl: './tickets.component.html',
  styleUrl: './tickets.component.scss'
})
export class TicketsComponent {

  isBulkUpdate: boolean = false;
  isOpenAddDialog: boolean = false;
  isBulkDeleteTicket: boolean = false;
  isDeleteTicket: boolean = false;
  isUpdateTicket: boolean = false;
  visible: boolean = false; // For filter sidebar visibility
  filterLoading: boolean = false; // For filter loading state

 
  startDate: string = '';
  endDate: string = '';
  dataSource: any[] = [];
  exportItems: any[] = [];
  displayedColumns: any[] = [];

  totalRecords: number = 0;
  rows: number = 50; // Default page size
  pageSizeOptions = [10, 20, 50]; // Page size options for dropdown
  loading: boolean = false;

  editTicketData: any = null;
  tableView: boolean = true; // Toggle for table view

  selectedProducts: any[] = [];
  filtersOptions: any[] = [];
  users: any[] = [];

  callFilterdApi: boolean = false;
  filtersPayload: any = {};
  showTicketActivity: boolean = false;


  bulkActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Update Tickets',
          icon: 'pi pi-pencil',
          command: () => {
            this.isBulkUpdate = true;
          }
        },
        {
          label: 'Delete Tickets',
          icon: 'pi pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isBulkDeleteTicket = true;
          }
        }
      ]
    }
  ];

  activeTicketStatusIndex: number = 0;
  activeTicketStatusName: string = 'All Tickets';


  ticketStatuses = [
    "All Tickets",
    "New",
    "Open",
    "In Progress",
    "On Hold",
    "Esclated",
    "Resolved",
    "Closed",
    "Canceled",
    "Draft",
    "Reopened",
    "Deleted"
  ];

  toggleView() {
    this.tableView = !this.tableView;
  }

  leadActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isUpdateTicket = true;
          }
        },
        {
          label: 'Ticket Activity',
          icon: 'pi pi-fw pi-list',
          command: () => {
            this.showTicketActivity = true;
          }
        },
        {

          label: 'Delete Ticket',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteTicket = true
          }
        }
      ]
    }
  ]

  constructor(
    private api: TicketService,
    private localStorage: LocalStorageService,
    private router: Router,
    private userApi: UsersService
  ) {
  }

  routerSub: any = null;

  ngOnInit() {


    //   if (!sessionStorage.getItem('ticketsPageReloaded')) {
    //   sessionStorage.setItem('ticketsPageReloaded', 'true');
    //   window.location.reload();
    // } else {
    //   sessionStorage.removeItem('ticketsPageReloaded');
    // }

    this.setFilterOptions();
    this.setFixedColumn();
    this.getAllUsers();

    this.initCCP("https://gravitas-education.my.connect.aws/ccp-v2/");

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        // Re-init CCP only if the current route is /tickets or matches your route
        console.log("event", event.urlAfterRedirects)
        if (event.urlAfterRedirects.includes('manage-tickets')) {
          setTimeout(() => {
            this.initCCP("https://gravitas-education.my.connect.aws/ccp-v2/");
          }, 1000); // Give it a small delay
        }
      });

  }

  ngOnDestroy() {
    window.location.reload();
  }

  getAllUsers() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
        this.users = this.users.map((user: any) => {
          return {
            label: user.fname + " " + user.lname,
            value: user?.user_id
          };
        }
        );
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }




  // ngOnDestroy(): void {
  //   const containerDiv = document.getElementById("container-div");
  //   if (containerDiv) {
  //     containerDiv.innerHTML = ""; // Clear the iframe
  //   }
  //   this.isCCPLoaded = false; // Force reload on next visit
  // }




  setFilterOptions() {
    this.filtersOptions.push({ header: 'First Name', value: 'first_name', type: 'text' });
    this.filtersOptions.push({ header: 'Last Name', value: 'last_name', type: 'text' });
    this.filtersOptions.push({ header: 'Email', value: 'email', type: 'text' });
    this.filtersOptions.push({ header: 'Phone', value: 'phone', type: 'text' });
    this.filtersOptions.push({ header: 'Source', value: 'source', type: 'text' });
    this.filtersOptions.push({ header: 'Lead Status', value: 'lead_status', type: 'text' });
  }


  fnHandleAddd() {
    this.isOpenAddDialog = true;
  }

  handleSearch(event: any) {
    console.log(event);
    this.loadTickets({ first: 0, rows: this.rows }, event.value, event.selectedFilterAttribute);
  }


  loadTickets(event: any, searchValue?: string, searchAttribute?: string) {
    
    this.loading = true;

    if(this.callFilterdApi) {
      this.fetchFilteredTickets()
      return;
    }
    

    const page = (event.first / event.rows) * event.rows;
    const size = event.rows;

    const body: any = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campus_id": this.localStorage.getCampusId(),
      },
      "filter": null,
      "page": page,
      "limit": size,
      "order": {
        "col": "\"ticket\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    if (searchValue && searchAttribute) {
      body.filter = {
        ...body.filter,
        [searchAttribute]: searchValue
      }
    }

    if (this.startDate && this.endDate) {
      body.startDate = this.startDate;
      body.endDate = this.endDate;
    }

    if (this.activeTicketStatusName && this.activeTicketStatusName !== 'All Tickets') {
      body.where.ticket_status = this.activeTicketStatusName;
    }

    this.api.getAllTickets(body).subscribe({
      next: (data) => {
        this.dataSource = data.rows
        this.totalRecords = data.count;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  reloadTickets() {
    this.loadTickets({ first: 0, rows: this.rows });
  }

  handleDateFilter(event: any) {
    // console.log('Date Filter:', event);
    if (event.startDate && event.endDate) {
      this.startDate = event.startDate;
      this.endDate = event.endDate;
      this.loadTickets({ first: 0, rows: this.rows }, undefined, undefined);
    } else {
      this.startDate = '';
      this.endDate = '';
      this.loadTickets({ first: 0, rows: this.rows });
    }
  }

  handleResetFilters() {
    this.startDate = '';
    this.endDate = '';
    this.loadTickets({ first: 0, rows: this.rows });
  }

  setTicketEditData(ticket: any) {

    this.editTicketData = {
      initials: ticket.assignedUser?.fname ? ticket.assignedUser?.fname?.charAt(0).toUpperCase() : 'N/A',
      name: ticket.assignedUser
        ? `${ticket.assignedUser.fname || ''} ${ticket.assignedUser.lname || ''}`.trim() || 'Unknown'
        : 'Not Assigned',
      time: new Date(ticket.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      message: ticket.ticket_desc
        ? `${ticket.title} || ${ticket.ticket_desc}`
        : ticket.title || 'No description provided',
      status: ticket.ticket_status || 'New',
      priority: ticket.priority || 'Low priority',
      timeAgo: new Date(ticket.createdAt).toLocaleDateString() + ' | ' + new Date(ticket.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      id: ticket.id,
      title: ticket.title,
      ticket_id: ticket.ticket_id,
      created_by: ticket.created_by,
      updated_by: ticket.updated_by,
      attachments: ticket.attachments || [],
      source: ticket.source || 'Unknown',
      organization_id: ticket.organization_id,
      campus_id: ticket.campus_id,
      lead_id: ticket.lead_id || null,
      assign_to: ticket.assign_to || null,
      live_chat_data: ticket.live_chat_data || {},
      ticket_desc: ticket.ticket_desc || '',
      createdAt: ticket.createdAt,
      updatedAt: ticket.updatedAt,
    };
    // this.showTicketActivity = true; // Show the ticket activity tab
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'New': return '#3498db';       // Blue
      case 'Open': return '#f39c12';      // Orange
      case 'In Progress': return '#27ae60'; // Green
      case 'On Hold': return '#8e44ad';   // Purple
      case 'Esclated': return '#e67e22';  // Dark Orange
      case 'Resolved': return '#2ecc71';  // Light Green
      case 'Closed': return '#1FAF38';    // Dark Green
      case 'Canceled': return '#e74c3c';  // Red
      case 'Draft': return '#95a5a6';     // Gray
      case 'Reopened': return '#16a085';  // Teal
      case 'Deleted': return '#c0392b';   // Dark Red
      default: return '#7f8c8d';          // Default Gray
    }
  }



  handleTicketStatusFilter(status: string, index: number) {
    this.activeTicketStatusIndex = index;
    this.activeTicketStatusName = status;
    this.loadTickets({ first: 0, rows: this.rows }, undefined, undefined);
  }

  toggleFilter() {
    this.visible = !this.visible;
  }

  applyFilters(payload: any) {
    this.filtersPayload = payload;
    this.callFilterdApi = true; // Indicate that a filter API call is being
    this.fetchFilteredTickets();
  }

  removeFilters() {
    this.callFilterdApi = false; // Reset the flag
    this.filtersPayload = {}; // Clear the filters payload
    this.visible = false; // Hide the filter sidebar
    this.filterLoading = false; // Reset loading state
    this.loadTickets({ first: 0, rows: this.rows }); // Reload tickets without filters
  }

  fetchFilteredTickets() {

    this.filterLoading = true; // Set loading state

   
    const payload = {
      advanced_filters: this.filtersPayload,
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId(),
      where: this.filtersPayload.where || {},
      order: this.filtersPayload.order || { col: '"ticket"."updatedAt"', dir: 'DESC' },
      page: 0,
      limit: 50
    };

    // Assuming payload contains the necessary data to fetch tickets
    this.api.getFilteredTickets(payload).subscribe({
      next: (data) => {
        this.dataSource = data.rows;
        this.totalRecords = data.count;
        this.filterLoading = false; // Reset loading state
      },
      error: () => {
        this.filterLoading = false; // Reset loading state on error
      }
    });

  }














  private isCCPLoaded = false;

  initCCP(instanceUrl: string) {
    const containerDiv = document.getElementById("container-div");
    if (!containerDiv) return;

    if (this.isCCPLoaded) return; // Avoid multiple loads

    containerDiv.innerHTML = ""; // Clear old iframe if exists

    connect.core.initCCP(containerDiv, {
      ccpUrl: instanceUrl,
      loginPopup: true,
      region: "us-east-1",
      loginPopupAutoClose: true,      // optional, defaults to `false`
      loginOptions: {                 // optional, if provided opens login in new window
        autoClose: false,              // optional, defaults to `false`
        height: 600,                  // optional, defaults to 578
        width: 433,                   // optional, defaults to 433
        top: 0,                       // optional, defaults to 0
        left: 0                       // optional, defaults to 0
      },
      softphone: {
        allowFramedSoftphone: true,
        disableRingtone: false,
        ringtoneUrl: "./ringtone.mp3"
      },
      pageOptions: {
        enableAudioDeviceSettings: false,
        enablePhoneTypeSettings: true
      }
    });

    this.isCCPLoaded = true;
  }




  export(selectedFields: any) {

    // let param = {
    //   where: {
    //     organization_id: this.localStorage.getOrganizationId(),
    //     current_stage: 'registration',
    //     campus_id: this.localStorage.getCampusId(),
    //   },
    // };
    // this.messageService.add({
    //   severity: 'info', summary: 'Exporting',
    //   detail: 'Exporting data, please wait...',
    //   sticky: true
    // });

    // this.api.getAllLeadList(param).subscribe({
    //   next: (data: any) => {

    //     const mappedData = data.map((lead: any) => {
    //       let row: any = {};

    //       selectedFields.forEach((field: any) => {
    //         if (field.type === 'dynamic_fields') {
    //           // Handle dynamic fields
    //           row[field.label] = lead.dynamic_fields?.[field.value] || '';
    //         } else if (field.type === 'registration') {
    //           if (field.value === 'preferred_course') {
    //             row[field.label] = lead.registration?.course?.name || '';
    //           } else {
    //             console.log("field", field)
    //             console.log("lead", lead.registration?.[field.value])
    //             console.log("lead", lead.registration)
    //             row[field.label] = lead.registration?.[field.value] || '';
    //           }
    //         }
    //         else {
    //           row[field.label] = lead[field.value] || '';
    //         }
    //       });

    //       return row;
    //     });

    //     // Create worksheet & workbook
    //     const worksheet = XLSX.utils.json_to_sheet(mappedData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads');

    //     // Save the file
    //     const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //     const dataBlob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    //     const date = new Date();
    //     const fileName = `Leads_data_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}_${date.getTime()}.xlsx`;

    //     saveAs(dataBlob, fileName);


    //     this.messageService.clear();

    //     this.exportItems.forEach((item) => {
    //       item.checked = false;
    //     }
    //     );

    //   },
    //   error: (e) => {

    //     this.messageService.clear();
    //     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error exporting data' });

    //   },
    // });
  }

  setFixedColumn() {
    // Ticket Id	Title	Description	Status	Requested On	Updated On	Assigned To	Priority	Action

    this.displayedColumns.push({
      field: 'ticket_id',
      header: 'Ticket ID',
      type: 'ticket_id'
    });

    this.displayedColumns.push({
      field: 'title',
      header: 'Title',
      type: 'title'
    });

    this.displayedColumns.push({
      field: 'ticket_desc',
      header: 'Description',
      type: 'description'
    });

    this.displayedColumns.push({
      field: 'ticket_status',
      header: 'Status',
      type: 'ticket_status'
    });

    this.displayedColumns.push({
      field: 'createdAt',
      header: 'Requested On',
      type: 'date'
    });

    this.displayedColumns.push({
      field: 'updatedAt',
      header: 'Updated On',
      type: 'date'
    });

    this.displayedColumns.push({
      field: 'assigned_to',
      header: 'Assigned To',
      type: 'assigned_to'
    });

    this.displayedColumns.push({
      field: 'created_by',
      header: 'Created By',
      type: 'created_by'
    });

    this.displayedColumns.push({
      field: 'priority',
      header: 'Priority',
      type: 'priority'
    });

    this.displayedColumns.push({
      field: 'actions',
      header: 'Action',
      type: 'actions'
    });

  }

}
